import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Paragraph } from 'components/patterns/Typography'
import { Icon } from 'components/patterns'

export const StyledParagraph = styled(Paragraph)`
  margin-top: 4px;
`

export const StyledIcon = styled(Icon)`
  margin-right: 4px;
  margin-top: 1px;
  path {
    fill: ${themeColor('greySecondary')};
  }
`

export const Container = styled.div`
  border-radius: 8px;
  background-color: ${themeColor('warningPrimary')};
  padding: 2px 5px 3px 4px;
  width: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ showHintText }) => (showHintText ? `margin-bottom: 2px;` : '')}
`
